import { render, staticRenderFns } from "./DangerLevel.vue?vue&type=template&id=31f693da&scoped=true"
import script from "./DangerLevel.vue?vue&type=script&lang=js"
export * from "./DangerLevel.vue?vue&type=script&lang=js"
import style0 from "./DangerLevel.vue?vue&type=style&index=0&id=31f693da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f693da",
  null
  
)

export default component.exports